import { Icons } from '@healthinal/ui';
import { useNavigate } from '@tanstack/react-router';
import { HistoryDto, PatientBasicsDto } from '../../../api/generated/model';
import { DashedButton } from '../../../components/DashedButtonStyled.tsx';
import { HistoryEntry } from './HistoryEntry.tsx';

export function HistoryPatientCreated({ history, patient }: { history: HistoryDto; patient: PatientBasicsDto }) {
  const navigate = useNavigate();
  return (
    <HistoryEntry history={history} subject={'Neuer Indexpatient'} action={'angelegt von'} patient={patient}>
      <DashedButton
        endDecorator={<Icons.ArrowForward />}
        color={'neutral'}
        sx={{ alignSelf: 'start' }}
        onClick={() => navigate({ to: '/patients/$patientId', params: { patientId: history.patientId } })}>
        Zum Indexpatienten
      </DashedButton>
    </HistoryEntry>
  );
}
